/*
DRIVER DIGITAL CUSTOM FOOTER SCRIPTS

Vite includes all minified JS within the <head> in theme.liquid,
so we use this file when it's necessary to include scripts in the
footer, before the closing </body> tag.
*/

// Load all external links in a new tab
document.addEventListener('DOMContentLoaded', function () {
  const links = document.getElementsByTagName('a');
  const currentHost = window.location.hostname;

  // Process anchor tags
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const linkHost = link.hostname;

    // Open external links in a new tab
    if (linkHost && linkHost !== currentHost) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer'; // for security reasons
    }
  }
});

// Reveal timeline blocks on scroll
class TimelineReveal extends HTMLElement {
  constructor() {
    super();
    this.observer = this.initObserver();
  }

  connectedCallback() {
    this.blocks = this.querySelectorAll('.multi-column__item');
    this.blocks.forEach((block) => this.observer.observe(block));
  }

  initObserver() {
    //console.log('Timeline Observer is called');
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //console.log(entry.target)
          entry.target.classList.remove('opacity-0');
        }
      });
    }, options);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('timeline-reveal')) {
    customElements.define('timeline-reveal', TimelineReveal);
  }
});
